
export function getToken(){
    let tokenVal = JSON.parse(localStorage.getItem('tokenVal'))
    if(tokenVal){
        return tokenVal.value
    }
}
export function checkTelephone(tel) {
    /* 手机号校验规则*/
    const telCheck = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
    return telCheck.test(tel)
}  
export function switchCurrentVersion(versionValue){
    if (versionValue == 12){
        return 0

    }else if(versionValue == 14){
        return 2

    }else if(versionValue == 13){
        return 3

    }else if(versionValue == 15){
        return 7

    }else if(versionValue == 16){
        return 10

    }else if(versionValue == 17){
        return 8

    }else if(versionValue == 18){
        return 11

    }else if(versionValue == 19){
        return 9
    }else{
        return versionValue
    }

}
export const  urlencode  = (str)=>{
    str = (str + '').toString();

    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').
        replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
}